import { useMediaQuery, useTheme } from '@mui/material';

export function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}

type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export function useIsMediaQuery(breakpoint: Breakpoint) {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.only(breakpoint));
}
